/**
 * Context for managing Freecode data primarily loaded from server.
 */
import React, { useState, useEffect, useCallback } from 'react';

import { useStateRef } from 'hooks/useStateRef';
import { contestLanguages } from 'constants/languages';
import { executorDecompress } from 'functions/executorDecompress';
import { categories } from 'constants/tests';
import { useFreecodeContextLayout } from 'hooks/useContext';
import { editorTypes } from './FreecodeLayout/FreecodeLayoutConstants';

export const FreecodeContextData = React.createContext();

export const FreecodeContextDataProvider = ({ children }) => {
  const { editorType } = useFreecodeContextLayout();

  const [test, setTest] = useState(undefined);
  const [testImpl, setTestImpl] = useState(undefined);
  const [course, setCourse] = useState(undefined);
  const [sponsor, setSponsor] = useState(undefined);
  const [ticket, setTicket] = useState(undefined);
  const [languageData, setActualLanguageData] = useState(undefined);
  const [peekData, setPeekData] = useState(undefined);
  const [showFlowOverlay, setShowFlowOverlay] = useState(undefined);

  const [input, setInput, inputRef] = useStateRef(undefined);

  const setLanguageData = useCallback((newLanguageData) => {
    for (const key in newLanguageData) {
      newLanguageData[key].icon = contestLanguages.find((data) => data.value === key)?.icon;
    }
    setActualLanguageData(newLanguageData);
  }, []);

  useEffect(() => {
    if (!testImpl?.generated?.peekResponse) return;
    let data = executorDecompress(testImpl.generated.peekResponse);
    if (!data?.length) return;
    if (editorType === editorTypes.creator && test.category === categories.EXERCISE.category) {
      data = data.slice(0, testImpl.configLevels.numPublic + testImpl.configLevels.numHidden);
    } else {
      data = data.slice(0, testImpl.configLevels.numPublic);
    }
    setPeekData(data);
  }, [testImpl?.generated, testImpl?.configLevels, setPeekData, editorType, test?.category]);

  return (
    <FreecodeContextData.Provider
      value={{
        peekData,
        test,
        setTest,
        testImpl,
        setTestImpl,
        course,
        setCourse,
        sponsor,
        setSponsor,
        ticket,
        setTicket,
        languageData,
        setLanguageData,
        input,
        setInput,
        inputRef,
        showFlowOverlay,
        setShowFlowOverlay,
      }}
    >
      {children}
    </FreecodeContextData.Provider>
  );
};
